import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * A busca por código ou nome da estrutura organizacional (spec 2026-10-23, D43),
 * no estilo do campo do agente de configuração, com o x para limpar quando há texto.
 */
export function OrgSearchField({
  value,
  onChange,
}: {
  value: string;
  onChange(next: string): void;
}) {
  const { t } = useTranslation();
  const label = t("Search code or name…");

  return (
    <div className="flex h-8 min-w-[200px] max-w-[320px] flex-[1_1_220px] items-center gap-2 rounded-md border border-[#d4dae3] bg-white px-2.5 text-[#596b85] focus-within:ring-2 focus-within:ring-[#08254c]">
      <Search aria-hidden="true" className="h-3.5 w-3.5 shrink-0" />
      <input
        type="search"
        aria-label={label}
        placeholder={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-w-0 flex-1 bg-transparent text-[13px] text-[#08254c] outline-none placeholder:text-[#7b8799] [&::-webkit-search-cancel-button]:hidden"
      />
      {value !== "" && (
        <button
          type="button"
          aria-label={t("Clear")}
          onClick={() => onChange("")}
          className="rounded text-[#7b8799] hover:text-[#08254c] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#08254c]"
        >
          <X aria-hidden="true" className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
